import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    // {
    //     id: 1,
    //     label: 'MENUITEMS.MENU.TEXT',
    //     isTitle: true
    // },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'bx-home-circle',
        // badge: {
        //     variant: 'info',
        //     text: '',
        // },
        subItems: [
            {
                id: 3,
                label: 'MENUITEMS.DASHBOARDS.LIST.DEFAULT',
                link: '/dashboard',
                parentId: 2
            },

        ]
    },
    {
        id: 500,
        label: 'EMPLOYEE',
        icon: 'bx-store',
        subItems: [
            {
                id: 501,
                label: 'ONBOARD',
                link: 'onboard/franchise',
                parentId: 500
            },
            {
                id: 502,
                label: 'ROLE MASTER',
                link: 'onboard/rbac/roles',
                parentId: 500
            },
            {
                id: 503,
                label: 'PERMISSION MASTER',
                link: 'onboard/rbac/permissions',
                parentId: 500
            },
            {
                id: 504,
                label: 'EMPLOYEE ROLES',
                link: 'onboard/rbac/userroles',
                parentId: 500
            },
            {
                id: 505,
                label: 'ROLE PERMISSIONS',
                link: 'onboard/rbac/rolepermissions',
                parentId: 500
            },
            {
                id: 506,
                label: 'RESET PASSWORD',
                link: 'onboard/reset-password',
                parentId: 500
            },
            {
                id: 507,
                label: 'EMPLOYEE CHECK-IN REPORT',
                link: 'onboard/employee-checkin-report',
                parentId: 500
            },


        ]
    },

    {
        id: 44,
        label: 'MENUITEMS.TASKS.TEXT',
        icon: 'bx-task',
        subItems: [
            // {
            //     id: 45,
            //     label: 'MENUITEMS.TASKS.LIST.TASKLIST',
            //     link: '/tasks/list',
            //     parentId: 44
            // }, 
            // {
            //     id: 46,
            //     label: 'MENUITEMS.TASKS.LIST.KANBAN',
            //     link: '/tasks/kanban',
            //     parentId: 44
            // },
            {
                id: 47,
                label: 'MENUITEMS.TASKS.LIST.CREATETASK',
                link: '/tasks/create',
                parentId: 44
            },
            // {
            //     id: 48,
            //     label: 'MENUITEMS.TASKS.LIST.TIMESHEET',
            //     link: '/tasks/timesheet',
            //     parentId: 44
            // },
            {
                id: 49,
                label: 'TASKREPORT',
                link: '/tasks/taskreport',
                parentId: 44
            }
        ]
    },
    {
        id: 100,
        label: 'CLIENT',
        icon: 'bx-user',
        subItems: [
            {
                id: 101,
                label: 'NEW CLIENT',
                link: '/onboard/newclient',
                parentId: 100
            },
            {
                id: 102,
                label: 'BILLS',
                link: '/onboard/listofbill',
                parentId: 100
            },
            {
                id: 103,
                label: 'RECEIPTS',
                link: '/onboard/listofreceipt',
                parentId: 100
            },
            {
                id: 104,
                label: 'LEDGER ENTRIES',
                link: '/onboard/ledgerentry',
                parentId: 100
            }
            
        ]
    },
    {
        id: 200,
        label: 'SETTING',
        icon: 'bx-cog',
        subItems: [
            {
                id: 201,
                label: 'GEO FENCING',
                link: '/setting/configure',
                parentId: 200
            },
            {
                id: 202,
                label: 'Entity',
                link: '/setting/entity',
                parentId: 200
            },
            {
                id: 203,
                label: 'Pricing',
                link: '/utility/pricing',
                parentId: 200
            },
            
        ]
    },



];
export const MENUFranchise: MenuItem[] = [
    // {
    //     id: 1,
    //     label: 'MENUITEMS.MENU.TEXT',
    //     isTitle: true
    // },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'bx-home-circle',
        // badge: {
        //     variant: 'info',
        //     text: 'MENUITEMS.DASHBOARDS.BADGE',
        // },
        subItems: [
            {
                id: 3,
                label: 'MENUITEMS.DASHBOARDS.LIST.DEFAULT',
                link: '/dashboard',
                parentId: 2
            },

        ]
    },
    // {
    //     id: 7,
    //     isLayout: true
    // },
    // {
    //     id: 8,
    //     label: 'MENUITEMS.APPS.TEXT',
    //     isTitle: true
    // },
    
    {
        id: 44,
        label: 'MENUITEMS.TASKS.TEXT',
        icon: 'bx-task',
        subItems: [
            
            // {
            //     id: 46,
            //     label: 'MENUITEMS.TASKS.LIST.KANBAN',
            //     link: '/tasks/kanban',
            //     parentId: 44
            // },
            
            {
                id: 48,
                label: 'MENUITEMS.TASKS.LIST.TIMESHEET',
                link: '/tasks/timesheet',
                parentId: 44
            },
            {
                id: 49,
                label: 'TASKREPORT',
                link: '/tasks/taskreport',
                parentId: 44
            }
        ]
    },
    {
        id: 100,
        label: 'CLIENT',
        icon: 'bx-task',
        subItems: [
            {
                id: 101,
                label: 'NEW CLIENT',
                link: '/onboard/newclient',
                parentId: 100
            },
            {
                id: 102,
                label: 'BILLS',
                link: '/onboard/listofbill',
                parentId: 100
            },
            // {
            //     id: 104,
            //     label: 'LEDGER ENTRIES',
            //     link: '/onboard/ledgerentry',
            //     parentId: 100
            // },
             {
                id: 103,
                label: 'RECEIPTS',
                link: '/onboard/listofreceipt',
                parentId: 100
            }, 
            
        ]
    },

];
export const MENUManager: MenuItem[] = [
    
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'bx-home-circle',
        subItems: [
            {
                id: 3,
                label: 'MENUITEMS.DASHBOARDS.LIST.DEFAULT',
                link: '/dashboard',
                parentId: 2
            },

        ]
    },
    {
        id: 500,
        label: 'EMPLOYEE',
        icon: 'bx-store',
        subItems: [
            {
                id: 501,
                label: 'ONBOARD',
                link: 'onboard/franchise',
                parentId: 500
            },
            {
                id: 506,
                label: 'RESET PASSWORD',
                link: 'onboard/reset-password',
                parentId: 500
            },


        ]
    },

    
    {
        id: 44,
        label: 'MENUITEMS.TASKS.TEXT',
        icon: 'bx-task',
        subItems: [
            {
                id: 48,
                label: 'MENUITEMS.TASKS.LIST.TIMESHEET',
                link: '/tasks/timesheet',
                parentId: 44
            },
            {
                id: 49,
                label: 'TASKREPORT',
                link: '/tasks/taskreport',
                parentId: 44
            }
        ]
    },
    {
        id: 100,
        label: 'CLIENT',
        icon: 'bx-task',
        subItems: [
            {
                id: 101,
                label: 'NEW CLIENT',
                link: '/onboard/newclient',
                parentId: 100
            },
            {
                id: 102,
                label: 'BILLS',
                link: '/onboard/listofbill',
                parentId: 100
            },
             {
                id: 103,
                label: 'RECEIPTS',
                link: '/onboard/listofreceipt',
                parentId: 100
            }, 
            
        ]
    },

];


